import React, { FunctionComponent } from 'react'
import {
  Text,
  StyleSheet
} from 'react-native'

const MyText = (props) => {
  return (
    <Text {...props} onPress={props.onPress} style={[{fontFamily: 'Comfortaa-Regular', fontSize: 12, color: '#474747'}, props.style]}>
      {props.children}
    </Text>
  )
}
const styles = StyleSheet.create({
})
export default MyText